import { Link } from "react-router-dom";
import { patternBg } from "@/lib/patternBg";
import { Instagram, MessageCircle } from "lucide-react";
import { LEGAL_PAGES, NAV, SITE, whatsappUrl } from "@/config/site";
import { PaymentBadges } from "./PaymentBadges";
import { getCategories, getCollections } from "@/lib/catalog";

// Tem de coincidir com os métodos ativos na Stripe (Definições → Pagamentos → Métodos de pagamento).
const PAYMENT_METHODS = ["Cartão", "MB Way", "Multibanco", "Apple Pay", "Revolut Pay", "Klarna"];

const Col = ({ title, children, cols = false }) => (
  <div>
    <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-bordeaux sm:mb-3">{title}</p>
    {/* telemóvel: a lista da loja ocupa duas colunas (menos altura) */}
    <ul className={`text-sm ${cols ? "grid grid-cols-2 gap-x-4 lg:block" : ""}`}>{children}</ul>
  </div>
);

const FLink = ({ to, children, testId }) => (
  <li>
    <Link to={to} data-testid={testId} className="bb-link bb-tap text-ink/80 hover:text-bordeaux">{children}</Link>
  </li>
);

export const Footer = () => (
  <footer className="bb-scallop-top relative mt-16 overflow-hidden bg-[#D9BDB6] pt-[var(--scallop)] text-ink" style={patternBg("vichy-rosa-claro", "217,189,182", 0.8, 240)} data-testid="site-footer">
    <div className="bb-container grid grid-cols-2 gap-x-6 gap-y-8 py-10 sm:gap-y-10 sm:py-14 lg:grid-cols-12 lg:py-20">
      <div className="col-span-2 lg:col-span-4">
        <p className="font-[Pacifico] text-4xl leading-none">Babybib</p>
        <p className="mt-3 max-w-xs text-sm leading-relaxed text-ink/70 sm:mt-5">{SITE.tagline}. Peças feitas à mão por mim. <span aria-hidden="true" className="text-bordeaux">♡</span></p>
        <div className="mt-4 flex flex-wrap gap-2 sm:mt-6">
          <a href={SITE.instagram.url} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="inline-flex min-h-[44px] items-center gap-2 rounded-full border border-ink/25 px-4 text-sm text-ink transition-colors hover:border-bordeaux hover:text-bordeaux">
            <Instagram className="h-4 w-4" /> {SITE.instagram.handle}
          </a>
          {whatsappUrl() && (
            <a href={whatsappUrl("Olá Alexandra! Gostava de saber mais 😊")} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="inline-flex min-h-[44px] items-center gap-2 rounded-full border border-ink/25 px-4 text-sm text-ink transition-colors hover:border-bordeaux hover:text-bordeaux">
              <MessageCircle className="h-4 w-4" /> WhatsApp
            </a>
          )}
        </div>
      </div>
      <div className="col-span-2 lg:col-span-2">
        <Col title="Loja" cols>
          {getCategories().map((c) => <FLink key={c.id} to={`/loja?categoria=${c.id}`} testId={`footer-cat-${c.id}`}>{c.name}</FLink>)}
          {getCollections().map((c) => <FLink key={c.slug} to={`/colecoes/${c.slug}`} testId={`footer-collection-${c.slug}`}>{c.label}</FLink>)}
        </Col>
      </div>
      <div className="lg:col-span-3">
        <Col title="Babybib">
          {NAV.slice(1).map((n) => <FLink key={n.to} to={n.to} testId={`footer-${n.testId}`}>{n.label}</FLink>)}
          <FLink to="/carrinho" testId="footer-cart">Carrinho</FLink>
          <FLink to="/contactos" testId="footer-contact">Contactos</FLink>
          <FLink to="/perguntas-frequentes" testId="footer-faq">Perguntas frequentes</FLink>
        </Col>
      </div>
      <div className="lg:col-span-3">
        <Col title="Informação">
          {LEGAL_PAGES.map((p) => <FLink key={p.slug} to={`/${p.slug}`} testId={`footer-legal-${p.slug}`}>{p.title}</FLink>)}
          <li>
            <a href="https://www.livroreclamacoes.pt/" target="_blank" rel="noopener noreferrer" data-testid="footer-complaints-book" className="bb-link bb-tap text-ink/80 hover:text-bordeaux">Livro de reclamações</a>
          </li>
        </Col>
      </div>
    </div>
    <div className="border-t border-ink/10">
      <div className="bb-container flex flex-wrap items-center gap-2 pt-5 text-xs text-ink/65" data-testid="footer-payment-methods">
        <span className="mr-1">Pagamento seguro com a Stripe</span>
        <PaymentBadges methods={PAYMENT_METHODS} />
      </div>
      <div className="bb-container py-5 text-xs text-ink/65">
        <p>© {new Date().getFullYear()} Babybib.</p>
      </div>
    </div>
  </footer>
);
